import { useFlyTo } from 'app/agriculture/hooks/useFlyTo/useFlyTo';
import { Button } from 'app/agriculture/components/Button/Button';
import { TargetIcon } from 'app/agriculture/icons';
import './ShowOnMapButton.scss';
import { Position } from 'app/agriculture/queries/types/geometry/Position';

interface ShowOnMapButtonProps {
    position?: Position | null;
}

export function ShowOnMapButton({ position }: ShowOnMapButtonProps) {
    const { flyTo } = useFlyTo();

    if (position == null) return null;

    return (
        <Button
            className="ShowOnMapButton"
            variant="compact"
            startIcon={<TargetIcon />}
            onClick={() => {
                flyTo(position).catch((e: unknown) => {
                    console.error(e);
                });
            }}
            text="Show on Map"
        />
    );
}
